import Money from "js-money/lib";

export const money = (value, currency, showCurrency = true) => {
    if (!currency) {
        return;
    }

    if (!value || value == "NaN") {
        value = 0;
    }

    currency = Money[currency];

    value = parseInt(value);

    var symbol = currency.symbol;

    if (currency.code == 'AUD') {
        symbol = "A$";
    }

    if (currency.code == 'ISK') {
        return 'kr' + (value / 100);
    }

    if (!showCurrency) {
        return (new Money(value, currency).toLocaleString());
    }

    return symbol + (new Money(value, currency).toLocaleString());
};



// WEBPACK FOOTER //
// ./src/Assets/components/Utility/filters/money.js